<template>
  <!-- v-dom-portal="true" -->
  <div  class="forget-pwd-wrapper">
    <div class="forget-pwd">
      <h2 class="forget-pwd_title">找回密码 <i class="iconfont icon-guanbi" v-on:click="closeForget"></i></h2>
      <div class="forget-pwd_tabs">
        <div class="forget-pwd_tabs-title">
          <dl>
            <dt v-bind:class="stepOne">1</dt>
            <dd>确定账号</dd>
          </dl>
          <dl>
            <dt v-bind:class="stepTwo">2</dt>
            <dd>验证码</dd>
          </dl>
          <dl>
            <dt v-bind:class="stepThree">3</dt>
            <dd>重置密码</dd>
          </dl>
          <dl>
            <dt v-bind:class="stepFour">4</dt>
            <dd>完成</dd>
          </dl>
        </div>
        <div class="forget-pwd_tabs-content" v-if="step == 1">
          <div class="forget-input">
            <i class="iconfont icon-shouji"></i>
            <input type="text" v-model="forget.number" placeholder="请输入手机号" autofocus />
          </div>
          <div class="forget-btn">
            <button class="btn-default solid long" v-on:click="stepClickOne">下一步</button>
          </div>
        </div>
        <div class="forget-pwd_tabs-content" v-if="step == 2">
          <p class="forget-reset_tel">
            您正在重置密码的账号为：
            <i class="orange">{{ forget.number }}</i>
          </p>
          <div class="forget-code">
            <div class="forget-input">
              <i class="iconfont icon-email"></i>
              <input type="text" v-model="forget.code" placeholder="请输入验证码" />
            </div>
            <button v-on:click="getCode" v-if="show">获取手机验证码</button>
            <button v-else>{{count}}秒后重新获取</button>
          </div>
          <div class="forget-btn">
            <button class="btn-default solid long" v-on:click="stepClickTwo">下一步</button>
          </div>
        </div>
        <div class="forget-pwd_tabs-content" v-if="step == 3">
          <div class="forget-input">
            <i class="iconfont icon-lock"></i>
            <input type="password" v-model="forget.newPassword" placeholder="请输入新密码" />
          </div>
          <div class="forget-input mt10">
            <i class="iconfont icon-yicizhihang"></i>
            <input type="password" v-model="forget.confirmPassword" placeholder="请输入确认密码" />
          </div>
          <div class="forget-btn">
            <button class="btn-default solid long" v-on:click="stepClickThree">下一步</button>
          </div>
        </div>
        <div class="forget-pwd_tabs-content" v-if="step == 4">
          <p class="forget-reset_success">
            <i class="iconfont icon-chenggong"></i>新密码已设置成功
          </p>
          <div class="forget-btn">
            <button class="btn-default solid long" @click="goLogin">返回登录</button>
            <button class="btn-default sub long mt10" @click="goIndex">返回首页</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/util/bus";

export default {
  name: "forgetPwd",
  data() {
    return {
      showForgetPwdPop: true,
      step: 1,
      forget: {
        number: "",
        code: "",
        newPassword: "",
        confirmPassword: ""
      },
      show: true,
      count: null,
      codeNew: "",
      completed: true
    };
  },
  computed: {
    stepOne() {
      return "finished";
    },
    stepTwo() {
      return this.step >= 2 ? "finished" : "";
    },
    stepThree() {
      return this.step >= 3 ? "finished" : "";
    },
    stepFour() {
      return this.step >= 4 ? "finished" : "";
    }
  },
  methods: {
    stepClickOne() {
      if (this.forget.number === "") {
        this.$Message.warning({
          content: "手机号不能为空！",
          duration: 3
        });
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.forget.number)) {
        this.$Message.warning("请填写正确的手机号！");
        return;
      }
      this.step = 2;
    },
    //获取手机验证码
    getCode() {
      this.$Axios
        .post("openApis/sendSMS", {
          mobileNo: this.forget.number,
          resetCheck: true
        }).then(res => {
          console.log(res);
          if (res.success) {
            // this.codeNew = res.data;
            this.info1(false);

            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                  } else {
                      this.show = true;
                      clearInterval(this.timer);
                      this.timer = null;
                  }
              }, 1000)
            }
          }else {
            this.$Message.error(res.message)
          }
        });
    },
    info1(nodesc) {
      this.$Notice.info({
        title: "提示",
        desc: nodesc ? "" : "验证码有效期为2分钟，过期需要重新获取. "
      });
    },
    stepClickTwo() {
    /*  if (this.codeNew !== this.forget.code) {
        this.$Message.error("验证码输入错误");
        return;
      }*/
      this.step = 3;
    },
    stepClickThree() {
      if (this.forget.newPassword !== this.forget.confirmPassword) {
        this.$Message.warning("密码不一致！");
        return;
      }
      this.$Axios.post("userInfo/restPassword", {
        checkCode: this.forget.code,
        logonUser: this.forget.number,
        pwd: this.forget.newPassword
      }).then(res => {
        if (res.success) {
          this.step = 4;
        } else {
          this.$Message.error(res.errors[0].message);
        }
      });
    },
    closeForget() {
      bus.$emit('showLogin',4);
    },
    //返回登录
    goLogin() {
      bus.$emit('showLogin',1);
    },
    //返回首页
    goIndex() {
      bus.$emit('showLogin',4);
      this.$router.push('/');
    }

  },
};
</script>

<style lang="less" scoped>
.forget-pwd-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  .forget-pwd {
    width: 800px;
    height: 500px;
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
    &_title {
      height: 50px;
      line-height: 50px;
      font-size: 18px;
      color: #fff;
      text-align: center;
      background: #fd6621;
      position: relative;
      .iconfont{
        position: absolute;
        top: -10px;
        right: 8px;
        cursor: pointer;
      }
    }
    &_tabs {
      padding: 76px 0 0;
      &-title {
        display: flex;
        justify-content: center;
        dl {
          text-align: center;
          padding-right: 80px;
          dt {
            width: 56px;
            height: 52px;
            line-height: 38px;
            font-size: 24px;
            color: #fff;
            background: url("../../assets/images/login/forget-icon1.png")
              no-repeat center;
            position: relative;
            &:after {
              content: "";
              position: absolute;
              top: 20px;
              left: 56px;
              width: 80px;
              height: 4px;
              border-radius: 2px;
              background: #e3e3e3;
            }
            &.finished {
              background: url("../../assets/images/login/forget-icon2.png")
                no-repeat center;
              &:after {
                background: #fd6621;
              }
            }
          }
          dd {
            line-height: 24px;
            font-size: 14px;
            padding-top: 20px;
          }
          &:last-child {
            padding-right: 0;
            dt {
              &:after {
                width: 0;
              }
            }
          }
        }
      }
      &-content {
        width: 300px;
        margin: 50px auto 0;
        .forget-input {
          display: flex;
          width: 100%;
          height: 40px;
          line-height: 40px;
          border: 1px solid #bcbcbc;
          border-radius: 4px;
          overflow: hidden;
          i {
            width: 40px;
            text-align: center;
            border-right: 1px solid #bcbcbc;
          }
          input {
            width: calc(100% - 40px);
            border: 0;
            padding: 0 10px;
          }
        }
        .forget-code {
          display: flex;
          .forget-input {
            flex: 1;
          }
          button {
            width: 110px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            color: #666;
            border-radius: 4px;
            background: #e3e3e3;
            margin-left: 10px;
          }
        }
        .forget-reset_tel {
          line-height: 1;
          text-align: center;
          margin-bottom: 28px;
        }
        .forget-reset_success {
          display: flex;
          justify-content: center;
          line-height: 40px;
          font-size: 16px;
          color: #58ca18;
          i {
            font-size: 40px;
            color: #58ca18;
            padding-right: 12px;
          }
        }
        .forget-btn {
          padding-top: 30px;
          button {
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login/forgetPwd.vue